import React from "react"
import { Link } from "react-router-dom"
import { CTA_TRATAMENTO, DIAGNOSTICO, DIAGNOSTICO_SUBTITULO } from "../../lib/narrativa"
import type { AccessSummary, Oferta } from "../../types"

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" })
}

/**
 * Faixa fina do plano no painel: "ativo até X" ou o que o diagnóstico gratuito
 * ainda cobre, e o
 * convite pro plano. Nunca bloqueia nada — só informa e aponta pra /plano.
 */
export function AccessCard({ access, nivelamentoAvailable, oferta }: { access: AccessSummary; nivelamentoAvailable: boolean; oferta: Oferta | null }) {
  if (access.active && access.expires_at) {
    const soon = access.days_left <= 3
    return (
      <div
        className={`flex items-center justify-between gap-3 rounded-2xl border px-4 py-3 text-sm ${
          soon ? "border-gold-300 bg-gold-50" : "border-emerald-200 bg-emerald-50"
        }`}
      >
        <p className="text-navy-800">
          <span className={`font-bold ${soon ? "text-gold-700" : "text-emerald-700"}`}>Tratamento ativo</span> até{" "}
          <span className="font-semibold">{formatDate(access.expires_at)}</span>
          {soon && <span className="text-navy-600"> · vence em {access.days_left} {access.days_left === 1 ? "dia" : "dias"}</span>}
        </p>
        <Link to="/plano?origem=dashboard" className="shrink-0 text-xs font-semibold text-navy-600 underline-offset-2 hover:underline">
          {soon ? "Renovar" : "Ver método"}
        </Link>
      </div>
    )
  }

  // Antes de existir diagnóstico não há tratamento a vender: oferecer plano com
  // preço a quem ainda não fez o nivelamento inverte a ordem da narrativa (e é
  // o primeiro elemento que o recém-cadastrado vê). Aqui o convite é o grátis;
  // o preço só entra depois que houver resultado.
  if (nivelamentoAvailable) {
    return (
      <div className="flex flex-col gap-2 rounded-2xl border border-gold-300 bg-gold-50/70 px-4 py-3 text-sm sm:flex-row sm:items-center sm:justify-between">
        <p className="text-navy-700">
          <span className="font-bold text-navy-900">{DIAGNOSTICO}:</span> {DIAGNOSTICO_SUBTITULO} Sem cartão.
        </p>
        <span className="shrink-0 text-xs font-semibold text-navy-500">Escolha sua prova abaixo ↓</span>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm sm:flex-row sm:items-center sm:justify-between">
      <p className="text-navy-700">
        <span className="font-bold text-navy-900">Etapa 2 em andamento.</span> Você ainda tem 1 diagnóstico grátis por matéria.
      </p>
      <Link to="/plano?origem=dashboard" className="shrink-0 text-xs font-semibold text-gold-700 underline-offset-2 hover:underline">
        {CTA_TRATAMENTO}
        {oferta ? ` · ${oferta.price_formatted}, uma vez, ou ${oferta.installments}x de ${oferta.installment_formatted}` : ""} →
      </Link>
    </div>
  )
}
